class CartRemoveButton extends HTMLElement {
    constructor() {
        super(),
            this.addEventListener("click", (e) => {
                e.preventDefault();
                let t = this.closest("cart-items") || this.closest("cart-drawer-items");
                t.updateQuantity(this.dataset.index, 0);
            });
    }
}
customElements.define("cart-remove-button", CartRemoveButton);
class CartItems extends HTMLElement {
    constructor() {
        super(), (this.lineItemStatusElement = document.getElementById("shopping-cart-line-item-status") || document.getElementById("CartDrawer-LineItemStatus"));
        let e = debounce((e) => {
            this.onChange(e);
        }, ON_CHANGE_DEBOUNCE_TIMER);
        this.addEventListener("change", e.bind(this));
        window.addEventListener('protection-product:removed', () => {
            console.log('protection-product:removed triggered');
            this.onCartUpdate();
            this.updateCartBubble();
        });
    }
    cartUpdateUnsubscriber = void 0;
    connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (e) => {
            "cart-items" !== e.source && this.onCartUpdate();
        });
    }
    disconnectedCallback() {
        this.cartUpdateUnsubscriber && this.cartUpdateUnsubscriber();
    }
    onChange(e) {
        this.updateQuantity(e.target.dataset.index, e.target.value, document.activeElement.getAttribute("name"), e.target.dataset.quantityVariantId);
    }
    onCartUpdate() {
        console.log('onCartUpdate', this.tagName);
        "CART-DRAWER-ITEMS" === this.tagName
            ? fetch(`${routes.cart_url}?section_id=cart-drawer`)
                  .then((e) => e.text())
                  .then((e) => {
                      let t = new DOMParser().parseFromString(e, "text/html");
                      for (let r of ["cart-drawer-items", ".cart-drawer__footer"]) {
                          let a = document.querySelector(r),
                              i = t.querySelector(r);
                          a && i && a.replaceWith(i);
                      }
                  })
                  .catch((e) => {
                      console.error(e);
                  })
            : fetch(`${routes.cart_url}?section_id=main-cart-items`)
                  .then((e) => e.text())
                  .then((e) => {
                      let t = new DOMParser().parseFromString(e, "text/html"),
                          r = t.querySelector("cart-items");
                      this.innerHTML = r.innerHTML;
                  })
                  .catch((e) => {
                      console.error(e);
                  });
    }
    updateCartBubble() {
             console.log('updateCartBubble');
             fetch(`${routes.cart_url}?section_id=cart-icon-bubble`)
                  .then((e) => e.text())
                  .then((e) => {
                    let t = new DOMParser().parseFromString(e, "text/html");
                    let r = t.querySelector(".shopify-section").innerHTML;
                    document.querySelector("#cart-icon-bubble").innerHTML = r;
                  })
                  .catch((e) => {
                      console.error(e);
                  });
    }
    getSectionsToRender() {
        return [
            { id: "main-cart-items", section: document.getElementById("main-cart-items").dataset.id, selector: ".js-contents" },
            { id: "cart-icon-bubble", section: "cart-icon-bubble", selector: ".shopify-section" },
            { id: "cart-live-region-text", section: "cart-live-region-text", selector: ".shopify-section" },
            { id: "main-cart-footer", section: document.getElementById("main-cart-footer").dataset.id, selector: ".js-contents" },
        ];
    }
    updateQuantity(e, t, r, a) {
        this.enableLoading(e);
        let i = JSON.stringify({ line: e, quantity: t, sections: this.getSectionsToRender().map((e) => e.section), sections_url: window.location.pathname });
        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), body: i })
            .then((e) => e.text())
            .then((t) => {
                let i = JSON.parse(t),
                    n = document.getElementById(`Quantity-${e}`) || document.getElementById(`Drawer-quantity-${e}`),
                    s = document.querySelectorAll(".cart-item");
                if (i.errors) {
                    (n.value = n.getAttribute("value")), this.updateLiveRegions(e, i.errors);
                    return;
                }
                this.classList.toggle("is-empty", 0 === i.item_count);
                let c = document.querySelector("cart-drawer"),
                    l = document.getElementById("main-cart-footer");
                l && l.classList.toggle("is-empty", 0 === i.item_count),
                    c && c.classList.toggle("is-empty", 0 === i.item_count),
                    this.getSectionsToRender().forEach((e) => {
                        let t = document.getElementById(e.id).querySelector(e.selector) || document.getElementById(e.id);
                        t.innerHTML = this.getSectionInnerHTML(i.sections[e.section], e.selector);
                    });
                let o = i.items[e - 1] ? i.items[e - 1].quantity : void 0,
                    d = "";
                s.length === i.items.length && o !== parseInt(n.value) && (d = void 0 === o ? window.cartStrings.error : window.cartStrings.quantityError.replace("[quantity]", o)), this.updateLiveRegions(e, d);
                let m = document.getElementById(`CartItem-${e}`) || document.getElementById(`CartDrawer-Item-${e}`);
                m && m.querySelector(`[name="${r}"]`)
                    ? c
                        ? trapFocus(c, m.querySelector(`[name="${r}"]`))
                        : m.querySelector(`[name="${r}"]`).focus()
                    : 0 === i.item_count && c
                    ? trapFocus(c.querySelector(".drawer__inner-empty"), c.querySelector("a"))
                    : document.querySelector(".cart-item") && c && trapFocus(c, document.querySelector(".cart-item__name")),
                    publish(PUB_SUB_EVENTS.cartUpdate, { source: "cart-items", cartData: i, variantId: a });
            })
            .catch(() => {
                this.querySelectorAll(".loading__spinner").forEach((e) => e.classList.add("hidden"));
                let e = document.getElementById("cart-errors") || document.getElementById("CartDrawer-CartErrors");
                e.textContent = window.cartStrings.error;
            })
            .finally(() => {
                this.disableLoading(e);
            });
    }
    updateLiveRegions(e, t) {
        let r = document.getElementById(`Line-item-error-${e}`) || document.getElementById(`CartDrawer-LineItemError-${e}`);
        r && (r.querySelector(".cart-item__error-text").innerHTML = t), this.lineItemStatusElement.setAttribute("aria-hidden", !0);
        let a = document.getElementById("cart-live-region-text") || document.getElementById("CartDrawer-LiveRegionText");
        a.setAttribute("aria-hidden", !1),
            setTimeout(() => {
                a.setAttribute("aria-hidden", !0);
            }, 1e3);
    }
    getSectionInnerHTML(e, t) {
        return new DOMParser().parseFromString(e, "text/html").querySelector(t).innerHTML;
    }
    enableLoading(e) {
        let t = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        t.classList.add("cart__items--disabled");
        let r = this.querySelectorAll(`#CartItem-${e} .loading__spinner`),
            a = this.querySelectorAll(`#CartDrawer-Item-${e} .loading__spinner`);
        [...r, ...a].forEach((e) => e.classList.remove("hidden")), document.activeElement.blur(), this.lineItemStatusElement.setAttribute("aria-hidden", !1);
    }
    disableLoading(e) {
        let t = document.getElementById("main-cart-items") || document.getElementById("CartDrawer-CartItems");
        t.classList.remove("cart__items--disabled");
        let r = this.querySelectorAll(`#CartItem-${e} .loading__spinner`),
            a = this.querySelectorAll(`#CartDrawer-Item-${e} .loading__spinner`);
        r.forEach((e) => e.classList.add("hidden")), a.forEach((e) => e.classList.add("hidden"));
    }
}
customElements.define("cart-items", CartItems),
    customElements.get("cart-note") ||
        customElements.define(
            "cart-note",
            class e extends HTMLElement {
                constructor() {
                    super(),
                        this.addEventListener(
                            "input",
                            debounce((e) => {
                                let t = JSON.stringify({ note: e.target.value });
                                fetch(`${routes.cart_update_url}`, { ...fetchConfig(), body: t });
                            }, ON_CHANGE_DEBOUNCE_TIMER)
                        );
                }
            }
        );
